// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root_3T0hN","badges":"Comment_badges_27LtS","controls":"Comment_controls_3DPMZ","answer":"Comment_answer_2MWy_"};